export default __webpack_public_path__ + "static/media/social-linkedin-circle-512.0fdb1fe5.webp";